import { useI18n } from 'vue-i18n'
import { permissionsState } from '../services/permissionsService'
import { translationsService } from '../services/translationsService'
import { log } from '../utils/DebugLogger'

/**
 * Idioma da tela = idioma do usuário logado (chamado NS 2026-0087).
 *
 * O bootstrap (main.ts) escolhe o idioma uma vez, quando o app carrega. Sem
 * sessão ele carrega em pt-BR; o login navega sem recarregar a página, então
 * o usuário de outro idioma ficava em português até um F5. Chamado depois que
 * as permissões do login chegam: carrega as traduções do idioma do usuário e
 * troca o idioma da tela na hora.
 */
export function useUserLocale() {
  const { locale, mergeLocaleMessage } = useI18n({ useScope: 'global' })

  async function applyUserLocale(): Promise<void> {
    const alvo = permissionsState.normalizedLocale || 'pt-BR'
    if (locale.value === alvo) return

    try {
      const messages = await translationsService.initialize([alvo], ['Frontend'])
      mergeLocaleMessage(alvo, messages[alvo] || {})
      locale.value = alvo
      log('useUserLocale', 'applyUserLocale', 'Locale switched after login', { alvo })
    } catch (error) {
      // Sem as traduções, a tela segue no idioma atual: o login não pode travar por isso.
      log('useUserLocale', 'applyUserLocale', '⚠️ Could not load translations for user locale', { alvo, error })
    }
  }

  return { applyUserLocale }
}
